import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ServiceInjector } from '../classes/infrastructure/injector';
import Swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';
import { ThemeService } from './theme.service';
import { Router } from '@angular/router';
import { AppStateManageService } from './app-state-manage.service';
import { isNullOrUndefined } from '../../tools';
import { PasswordFlowMode } from './passwordflowmode';
import { AuthService } from '../shared/services/auth.service';
import { LanguageService } from './language.service';

class SwalResult {
  isConfirmed: boolean = false;
  isDenied: boolean = false;
  isDismissed: boolean = false;
}

@Injectable({
  providedIn: 'root'
})
export class UIUtils {
  private isPopupOpen = false;

  public static GetInstance(): UIUtils {
    return ServiceInjector.AppInjector.get(UIUtils)
  }

  constructor(private alertController: AlertController, private themeService: ThemeService, private router: Router, private appStateManage: AppStateManageService) { }

  public GlobalUIErrorHandler = async (errMsg: string) => {
    await this.showErrorMessage('Error', errMsg);
  }

  // old code without line breaks.. (Traditional )
  // public async showErrorMessage(title: string, msg: string,
  //   okHandler: () => Promise<void> = null as any) {
  //   if (msg === 'Locked') {
  //     // await this.showPasswordExpiredPopup();
  //     return;
  //   }
  //   if (msg === 'Ok') {
  //     // await this.showPasswordExpiredPopup();
  //     return;
  //   }
  //   let result: SweetAlertResult = await Swal.fire({
  //     title: title,
  //     text: msg,
  //     icon: 'error',
  //     confirmButtonText: 'OK',
  //     allowOutsideClick: false,
  //     backdrop: false, // Removes full-screen overlay
  //     position: 'center',
  //     customClass: {
  //       popup: 'custom-popup',
  //     },
  //   });
  //   if (result.isConfirmed) {
  //     if (!isNullOrUndefined(okHandler)) {
  //       await okHandler();
  //     }
  //     if (msg.toLowerCase().includes('invalid login token')) {
  //       this.appStateManage.StorageKey.clear()
  //       await this.router.navigate(['']);
  //       return
  //     }
  //     if (msg == 'Unable to get Role from login token') {
  //       this.appStateManage.StorageKey.clear()
  //       await this.router.navigate(['']);
  //       return
  //     }
  //     if (msg == 'Unauthorized' || msg.toLowerCase().includes('unauthorized')) {
  //       this.appStateManage.StorageKey.clear()
  //       await this.router.navigate(['']);
  //       return
  //     }
  //   }
  // }

// new code with line breaks for multiple messages and better formatting
  public async showErrorMessage(
  title: string,
  msg: string,
  okHandler: () => Promise<void> = null as any
) {
  if (!msg) return;

  if (msg === 'Locked' || msg === 'Ok') {
    return;
  }

  // ✅ Convert message into line-by-line format
  let formattedMessage = this.convertToList(msg);

  let result: SweetAlertResult = await Swal.fire({
    title: title,
    html: formattedMessage, // 🔥 IMPORTANT (not text)
    icon: 'error',
    confirmButtonText: LanguageService.GetInstance().currentLang === 'mr' ? 'ठीक आहे' : 'OK',
    allowOutsideClick: false,
    backdrop: false,
    position: 'center',
    customClass: {
      popup: 'custom-popup',
    },
  });

  if (result.isConfirmed) {
    if (!isNullOrUndefined(okHandler)) {
      await okHandler();
    }

    // 🔐 Auth handling (unchanged)
    if (msg.toLowerCase().includes('invalid login token')) {
      this.appStateManage.StorageKey.clear();
      await this.router.navigate(['']);
      return;
    }

    if (msg == 'Unable to get Role from login token') {
      this.appStateManage.StorageKey.clear();
      await this.router.navigate(['']);
      return;
    }

    if (msg == 'Unauthorized' || msg.toLowerCase().includes('unauthorized')) {
      this.appStateManage.StorageKey.clear();
      await this.router.navigate(['']);
      return;
    }
  }
}


private convertToList(msg: string): string {
  // ✅ If already HTML → don't touch
  if (msg.includes("<") && msg.includes(">")) {
    return msg;
  }

  let items: string[] = [];

  // ✅ Case 1: comma-separated
  if (msg.includes(",")) {
    items = msg.split(",");
  }
  // ✅ Case 2: newline-separated
  else if (msg.includes("\n")) {
    items = msg.split("\n");
  }
  // ✅ Case 3: single message
  else {
    return `<p>${msg}</p>`;
  }

  // ✅ Convert to list
  return `
  <div style="display:flex; justify-content:center;">
    <ul style="text-align:left;">
      ${items
        .map((m) => m.trim())
        .filter((m) => m.length > 0)
        .map((m) => `<li>${m}</li>`)
        .join("")}
    </ul>
  </div>
`;
}


  public async showErrorMessagelang(title: string, msg: string,
  okHandler: () => Promise<void> = null as any) {
  if (msg === 'Locked') {
    return;
  }
  if (msg === 'Ok') {
    return;
  }

  const isMr = sessionStorage.getItem('app_lang') === 'mr'; // ✅

  let result: SweetAlertResult = await Swal.fire({
    title: title,
    text: msg,
    icon: 'error',
    confirmButtonText: isMr ? 'ठीक आहे' : 'OK',
    allowOutsideClick: false,
    backdrop: false,
    position: 'center',
    customClass: {
      popup: 'custom-popup',
    },
  });

  if (result.isConfirmed) {
    if (!isNullOrUndefined(okHandler)) {
      await okHandler();
    }
    if (msg.toLowerCase().includes('invalid login token')) {
      this.appStateManage.StorageKey.clear()
      await this.router.navigate(['']);
      return
    }
    if (msg == 'Unable to get Role from login token') {
      this.appStateManage.StorageKey.clear()
      await this.router.navigate(['']);
      return
    }
    if (msg == 'Unauthorized' || msg.toLowerCase().includes('unauthorized')) {
      this.appStateManage.StorageKey.clear()
      await this.router.navigate(['']);
      return
    }
  }
}

  public async showErrorMessageForPasswordExpire(
    title: string,
    msg: string,
    okHandler: () => Promise<void> = null as any
  ) {
    debugger
    if (msg === 'Locked') {
      return;
    }

    let result: SweetAlertResult = await Swal.fire({
      title: title,
      text: msg,
      icon: 'error',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      backdrop: false,
      position: 'center',
      customClass: {
        popup: 'custom-popup',
      },
    });

    if (result.isDismissed) {
      // let response = await this.authService.logOut();
      // if (!response?.Successful) alert(response?.message);

      return;
    }
  }
  public async showErrorMessageForSessionExpire(
    title: string,
    msg: string,
    okHandler: () => Promise<void> = null as any
  ) {

    if (msg === 'Please Relogin.' || msg == 'OK') {
      // return;
      let result: SweetAlertResult = await Swal.fire({
        title: title,
        text: msg,
        icon: 'error',
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        backdrop: false,
        position: 'center',
        customClass: {
          popup: 'custom-popup',
        },
      });

      if (result.isDismissed) {
        alert('logout');
        // this.router.navigate(["/login-form"]);
        // this.appStateManage.setPasswordFlowMode(PasswordFlowMode.EXPIRED);
        // this.router.navigate(["/Change-Expired-Password"]);
        // await this.router.navigate(['/Change_Password']);
        return;
      }
    }

  }

  private async showPasswordExpiredPopup() {
    this.isPopupOpen = true;

    const alert = await this.alertController.create({
      header: 'Password Expired',
      message: 'Your password has expired. Please change your password to continue.',
      backdropDismiss: false,
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.isPopupOpen = false;
            this.router.navigate(['/Change_Password']);
          }
        }
      ]
    });

    await alert.present();
  }

  public async showInformationalMessage(title: string, msg: string,
    okHandler?: () => Promise<void>) {
    let result = await Swal.fire(title, msg, 'info') as SwalResult;
    if (result.isConfirmed) {
      if (!isNullOrUndefined(okHandler)) {
        await okHandler!();
      }
      if (msg.toLowerCase().includes('invalid login token')) {
        this.appStateManage.StorageKey.clear()
        await this.router.navigate(['']);
        return
      }
    }
  }

  public async showInformationalMessagelang(title: string, msg: string,
  okHandler?: () => Promise<void>, isMr: boolean = false) {
  let result = await Swal.fire({
    title: title,
    text: msg,
    icon: 'info',
    confirmButtonText: isMr ? 'ठीक आहे ' : 'OK',
  }) as SwalResult;

  if (result.isConfirmed) {
    if (!isNullOrUndefined(okHandler)) {
      await okHandler!();
    }
    if (msg.toLowerCase().includes('invalid login token')) {
      this.appStateManage.StorageKey.clear()
      await this.router.navigate(['']);
      return
    }
  }
}

  toastMixin = Swal.mixin({
    toast: true,
    icon: 'success',
    title: 'General Title',
    animation: false,
    position: 'top-right',
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  public async showSuccessToster(title: string) {
    // Get the current theme from ThemeService
    const currentTheme = this.themeService.getCurrentTheme();

    // Determine background and text color based on the current theme
    // const backgroundColor = currentTheme === 'dark' ? 'white' : 'black'; // White background if dark theme, black otherwise
    // const textColor = currentTheme === 'dark' ? 'black' : 'white'; // Black text if dark theme, white otherwise

    // Use the toast mixin to show the toast
    this.toastMixin.fire({
      title: title,
      icon: 'success',
      //  background: backgroundColor, // Set background color based on theme
      //  color: textColor // Set text color based on theme
    });
  }

  private isAlertOpen = false;
  public async showConfirmationMessage(
    title: string,
    msg: string,
    confirmHandler: () => Promise<void> = null as any
  ) {
    // Prevent multiple popups from opening at the same time
    if (this.isAlertOpen) {
      return;
    }

    this.isAlertOpen = true; // Mark the alert as open

    try {
      let result: SweetAlertResult = await Swal.fire({
        title: title,
        html: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        allowOutsideClick: false,
        backdrop: false,
        position: 'center',
        customClass: {
          popup: 'custom-popup',
        },
      });

      if (result.isConfirmed && confirmHandler) {
        await confirmHandler(); // Execute the confirmation action
      }
    } catch (error) {
      // console.error("Error handling SweetAlert:", error);
    } finally {
      this.isAlertOpen = false; // Reset flag when alert is closed
    }
  }

public async showConfirmationMessagelang(
  title: string,
  msg: string,
  confirmHandler: () => Promise<void> = null as any
) {
  if (this.isAlertOpen) {
    return;
  }

  this.isAlertOpen = true;

  const isMr = sessionStorage.getItem('app_lang') === 'mr'; // ✅ correct key

  try {
    let result: SweetAlertResult = await Swal.fire({
      title: title,
      html: msg,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: isMr ? 'होय' : 'Yes',
      cancelButtonText: isMr ? 'नाही' : 'No',
      allowOutsideClick: false,
      backdrop: false,
      position: 'center',
      customClass: {
        popup: 'custom-popup',
      },
    });

    if (result.isConfirmed && confirmHandler) {
      await confirmHandler();
    }
  } catch (error) {
    // console.error("Error handling SweetAlert:", error);
  } finally {
    this.isAlertOpen = false;
  }
}

  // status confirmation message
  public async showStatusConfirmationMessage(
    title: string,
    msg: string,
    statusOptions: string[], // Example: ['Pending', 'Approved', 'Cancel']
    handler: (selectedStatus: string) => Promise<void>
  ) {
    if (this.isAlertOpen) return;
    this.isAlertOpen = true;

    try {
      const inputOptions: any = {};
      statusOptions.forEach((status) => {
        inputOptions[status] = status;
      });

      const result = await Swal.fire({
        title: title,
        html: msg,
        icon: 'question',
        showCancelButton: true,
        showDenyButton: statusOptions.length >= 2,
        confirmButtonText: statusOptions[0],
        denyButtonText: statusOptions[1] || '',
        cancelButtonText: statusOptions[2] || 'Cancel',
        allowOutsideClick: false,
        backdrop: false,
        position: 'center',
        customClass: {
          popup: 'custom-popup',
        },
      });

      if (result.isConfirmed) {
        await handler(statusOptions[0]);
      } else if (result.isDenied && statusOptions[1]) {
        await handler(statusOptions[1]);
      } else if (result.dismiss === Swal.DismissReason.cancel && statusOptions[2]) {
        await handler(statusOptions[2]);
      }

    } catch (error) {
      // console.error("Error handling SweetAlert:", error);
    } finally {
      this.isAlertOpen = false;
    }
  }

  public async showErrorToster(title: string) {
    this.toastMixin.fire({
      title: title,
      icon: 'error'
    });

    setTimeout(async () => {
      if (title.toLowerCase().includes('invalid login token')) {
        this.appStateManage.StorageKey.clear()
        await this.router.navigate(['']);
        return
      }
    }, 4000);
  }

  public async showWarningToster(title: string) {
    this.toastMixin.fire({
      title: title,
      icon: 'warning'
    });

    setTimeout(async () => {
      if (title.toLowerCase().includes('invalid login token')) {
        this.appStateManage.StorageKey.clear()
        await this.router.navigate(['']);
        return
      }
    }, 3000);
  }

  // public async askForConfirmation(title: string, msg: string,
  //   yesHandler?: () => void, noHandler?: () => void) {
  //   const alert = await this.alertController.create({
  //     header: title,
  //     message: msg,
  //     backdropDismiss: false,
  //     buttons: [
  //       {
  //         text: 'Yes',
  //         handler: yesHandler
  //       },
  //       {
  //         text: 'No',
  //         handler: noHandler
  //       }
  //     ]
  //   });

  //   await alert.present();
  // }

  public async askForConfirmation(title: string, msg: string,
    yesHandler: () => Promise<void> = null as any,
    noHandler: () => Promise<void> = null as any) {
    let result = await Swal.fire(<SweetAlertOptions>{
      title: title,
      html: msg,
      icon: 'question',
      showConfirmButton: true,
      showDenyButton: true,
      confirmButtonText: LanguageService.GetInstance().currentLang === 'mr' ? 'हो' : 'OK',
      denyButtonText: LanguageService.GetInstance().currentLang === 'mr' ? 'नाही' : 'Cancel',
    }) as SwalResult;

    if (result.isConfirmed) {
      if (!isNullOrUndefined(yesHandler)) {
        await yesHandler();
      }
    }
    else if (result.isDenied) {
      if (!isNullOrUndefined(noHandler)) {
        await noHandler();
      }
    }

    // const alert = await this.alertController.create({
    //   header: title,
    //   message: msg,
    //   backdropDismiss: false,
    //   buttons: [
    //     {
    //       text: 'No',
    //       handler: noHandler
    //     },
    //     {
    //       text: 'Yes',
    //       handler: yesHandler
    //     }
    //   ]
    // });

    // await alert.present();
  }

  public async askForConfirmationApprove(title: string, msg: string,
    yesHandler: () => Promise<void> = null as any,
    noHandler: () => Promise<void> = null as any) {
    let result = await Swal.fire(<SweetAlertOptions>{
      title: title,
      html: msg,
      icon: 'success',
      showConfirmButton: true,
      showDenyButton: true,
      confirmButtonText: 'Yes'
    }) as SwalResult;

    if (result.isConfirmed) {
      if (!isNullOrUndefined(yesHandler)) {
        await yesHandler();
      }
    }
    else if (result.isDenied) {
      if (!isNullOrUndefined(noHandler)) {
        await noHandler();
      }
    }
    //   header: title,
    //   message: msg,
    //   backdropDismiss: false,
    //   buttons: [
    //     {
    //       text: 'No',
    //       handler: noHandler
    //     },
    //     {
    //       text: 'Yes',
    //       handler: yesHandler
    //     }
    //   ]
    // });

    // await alert.present();
  }

  public async askForSaveConfirmation(title: string, msg: string,
    yesHandler: () => Promise<void> = null as any,
    noHandler: () => Promise<void> = null as any) {
    let result = await Swal.fire(<SweetAlertOptions>{
      title: title,
      html: msg,
      icon: 'info',
      showConfirmButton: true,
      showDenyButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No'   // ✅ REQUIRED
    }) as SwalResult;

    if (result.isConfirmed) {
      if (!isNullOrUndefined(yesHandler)) {
        await yesHandler();
      }
    }
    else if (result.isDenied) {
      if (!isNullOrUndefined(noHandler)) {
        await noHandler();
      }
    }
  }

  public async askForModalConfirmation(title: string, msg: string,
    yesHandler: () => Promise<void> = null as any,
    noHandler: () => Promise<void> = null as any) {
    let result = await Swal.fire(<SweetAlertOptions>{
      title: title,
      html: msg,
      confirmButtonText: 'Yes',
      showDenyButton: true
    }) as SwalResult;

    if (result.isConfirmed) {
      if (!isNullOrUndefined(yesHandler)) {
        await yesHandler();
      }
    }
    else if (result.isDenied) {
      if (!isNullOrUndefined(noHandler)) {
        await noHandler();
      }
    }

    // const alert = await this.alertController.create({
    //   header: title,
    //   message: msg,
    //   backdropDismiss: false,
    //   buttons: [
    //     {
    //       text: 'No',
    //       handler: noHandler
    //     },
    //     {
    //       text: 'Yes',
    //       handler: yesHandler
    //     }
    //   ]
    // });

    // await alert.present();
  }

  public async showAuthErrorPopup(
    title: string,
    message: string,
    onOk: () => Promise<void>
  ) {
    this.isPopupOpen = true;

    const alert = await this.alertController.create({
      header: title,
      message: message,
      backdropDismiss: false,
      buttons: [
        {
          text: 'OK',
          handler: async () => {
            this.isPopupOpen = false;
            await onOk();
          }
        }
      ]
    });

    await alert.present();
  }

  public async handleError(title: string, msg: string) {

    if (!msg) {
      this.showErrorToster(title);
      return;
    }

    // 🔴 Password expired (EXACT match from backend)
    if (msg === 'PasswordHasExpired') {
      await this.showPasswordExpiredPopupForLogin(
        'Password Expired',
        'Your password has expired. Please reset it to continue.'
      );
      return;
    }

    // 🔴 Invalid login token
    if (msg.toLowerCase().includes('invalid login token')) {
      await this.showInvalidTokenPopup(title, msg);
      return;
    }

    // 🟡 Any other error
    this.showErrorToster(msg);
  }

  private async showPasswordExpiredPopupForLogin(title: string, msg: string) {

    const result = await Swal.fire({
      title: title,
      text: msg,
      icon: 'error',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      backdrop: false,
      position: 'center',
      customClass: {
        popup: 'custom-popup',
      },
    });

    if (result.isConfirmed) {
      this.appStateManage.setPasswordFlowMode(PasswordFlowMode.EXPIRED);
      await this.router.navigate(['/forgot-password']);
    }
  }

  private async showInvalidTokenPopup(title: string, msg: string) {
    const result = await Swal.fire({
      title: title,
      text: msg,
      icon: 'error',
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      backdrop: false,
      position: 'center',
      customClass: {
        popup: 'custom-popup',
      },
    });

    if (result.isConfirmed) {
      this.appStateManage.StorageKey.clear();
      await this.router.navigate(['/bank']); // or '/'
    }
  }

}
